import Image from 'next/image';
import React from 'react';

const Logo = () => {
  return (
    <Image
      width={142}
      height={32}
      src="/logo/commenda-black.png"
      alt="Commenda Logo"
    />
  );
};

export default Logo;
